import React from 'react';
import { Field, reduxForm } from 'redux-form/immutable';
import PropTypes from 'prop-types';
import NavbarModulo from '../../components/NavbarModulo';
import DetalleGastos from './DetalleGastos';
import DetalleGastosMod from './DetalleGastosMod';
import DetalleGastosVer from './DetalleGastosVer';
import styled from 'styled-components';

import {
    renderField,
    AsyncSelectField,
    renderDayPickerB,
    renderCurrencyFloat,
    SelectField
} from "../../Utils/renderField/renderField";

function GastoForm(props) {
    const {
        crear,
        modulo,
        periodoD,
        registroGasto,
        listarFases,
        agregarLinea,
        detalleCon,
        modificarGasto,
        eliminarLinea,
        detalleS,
        nuevaLineaGasto,
        eliminarLineaGasto,
        listarGastos,
        lectura
    } = props;

    
    const estilo = {
        overflow: "auto",
        height: "200px",

    };

    const editar = window.location.href.includes('editar');
    let titulo = editar ? 'Modificar gasto' : 'Nuevo gasto';
    if (crear === false && editar === false) {
        titulo = 'Ver gasto'
    }

    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    
    const tipo = [
        { label: "DIRECTO", value: "D" },
        { label: "INDIRECTO", value: "I" },
    ];

    return (
        <div>
            <NavbarModulo
                periodoD = {periodoD}
                modulo = {modulo}
                titulo = {titulo}
            />
            <div className="mb-4 card card-small text-white bg-dark mb-3">
                <div className="p-0 pt-3 d-flex flex-column flex-md-row">
                    <div className="d-flex flex-column flex-1 mx-4">
                        {(crear === false && editar === false) &&
                                <div className='row mb-2'>
                                    <div className='col-3'>
                                        <Field
                                            name="fecha"
                                            component={renderDayPickerB}
                                            msj="Fecha inicio"
                                            disabled={true}
                                        />
                                    </div>
                                    <div className='col-3'>
                                        <Field
                                            name="tipo"
                                            options={tipo}
                                            crear={crear}
                                            dato={lectura.tipo_gasto}
                                            component={SelectField}
                                            className="form-select"
                                            msj="Tipo de gasto"
                                            disabled={true}
                                        />
                                    </div>
                                    <div className='col-6'>
                                        <div className='mb-2'>
                                            <Field
                                                name="descripcion_gasto"
                                                placeholder="Serie"
                                                component={renderField}
                                                className="form-control"
                                                msj="Gasto"
                                                disabled={true}
                                            />
                                        </div>
                                    </div>
                                </div>
                        }
                        {(crear === true) &&
                            <div>
                                <div className='row mb-2'>
                                    <div className='col-3'>
                                        <Field
                                            name="fecha"
                                            component={renderDayPickerB}
                                            msj="Fecha inicio"
                                        />
                                    </div>
                                    <div className='col-3'>
                                            <Field
                                                name="tipo"
                                                options={tipo}
                                                crear={crear}
                                                dato={0}
                                                component={SelectField}
                                                className="form-select"
                                                msj="Tipo de gasto"
                                            />
                                    </div>
                                    <div className='col-6'>
                                        <Field
                                            name="gasto"
                                            placeholder="Gasto..."
                                            className="form-control-find"
                                            loadOptions={listarGastos}
                                            component={AsyncSelectField}
                                            msj="Gasto"
                                        />
                                    </div>
                                </div>
                            </div>
                        }
                        {(editar === true) &&
                            <div>
                                <div className='row mb-2'>
                                    <div className='col-3'>
                                        <Field
                                            name="fecha_registro"
                                            component={renderDayPickerB}
                                            msj="Fecha inicio"
                                        />
                                        </div>
                                    <div className='col-3'>
                                        <Field
                                            name="tipo_gasto"
                                            options={tipo}
                                            crear={crear}
                                            dato={lectura.tipo_gasto}
                                            component={SelectField}
                                            className="form-select"
                                            msj="Tipo de gasto"
                                        />
                                    </div>
                                    <div className='col-6'>
                                        <div className='mb-2'>
                                            <Field
                                                name="descripcion_gasto"
                                                placeholder="Serie"
                                                component={renderField}
                                                className="form-control"
                                                msj="Gasto"
                                                disabled={true}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className='row mb-2'>
                                    <div className='col-3'>
                                    </div>
                                    <div className='col-3'>
                                    </div>
                                    <div className='col-6'>
                                        <Field
                                            name="gasto_mod"
                                            placeholder="Gasto..."
                                            className="form-control-find"
                                            loadOptions={listarGastos}
                                            component={AsyncSelectField}
                                            msj="Gasto"
                                        />
                                    </div>
                                </div>
                            </div>
                    
                        }
                        
                        {(crear === true || editar === true) &&
                            <div>
                                <h5 className="p-2 bg-secondary title mt-1">Detalle gastos</h5>
                                <div className='row mb-2'>
                                    <div className='col-5'>
                                        <Field
                                            name="fase"
                                            placeholder="Fase..."
                                            className="form-control-find"
                                            loadOptions={listarFases}
                                            component={AsyncSelectField}
                                            msj="Fase"
                                        />
                                    </div>                                    
                                    <div className='col-2'>
                                        <div className="form-floating">
                                            <Field
                                                name="monto"
                                                placeholder="Monto"
                                                className="form-control"
                                                component={renderCurrencyFloat}
                                                msj="Monto"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        {(crear === true) &&
                            <Contenido>
                                <button
                                    className='btn mr-2 mb-3 btn-primary'
                                    onClick={() => agregarLinea(periodoD)}
                                >
                                    Agregar linea
                                </button>
                            </Contenido>
                        }
                        {(editar === true) &&
                            <Contenido>
                                <button
                                    className='btn mr-2 mb-3 btn-primary'
                                    onClick={() => nuevaLineaGasto(periodoD)}
                                >
                                    Agregar linea
                                </button>
                            </Contenido>
                        }
                        {(crear === false && editar === false) &&
                            <div>
                                <h5 className="p-2 bg-secondary title mt-1">Detalle gastos</h5>
                                <div style={estilo}>
                                    <DetalleGastosVer
                                        detalle={detalleS}
                                    />
                                </div>
                            </div>
                        }
                        <br/>
                        {(crear === true) &&
                            <div style={estilo}>
                                <DetalleGastos
                                    detalle={detalleCon}
                                    eliminarLinea={eliminarLinea}
                                />
                            </div>
                        }
                        {(editar === true) &&
                            <div style={estilo}>
                                <DetalleGastosMod
                                    detalle={detalleS}
                                    eliminarLinea={eliminarLineaGasto}
                                />
                            </div>
                        }
                        <div className='d-flex flex-row mt-3'>
                            <br />
                            {crear == true &&
                                <button
                                    className='btn mr-2 mb-3 btn-primary'
                                    onClick={() => registroGasto(periodoD)}
                                >
                                    Guardar
                                </button>
                            }
                            {editar == true &&
                                <button
                                    className='btn mr-2 mb-3 btn-primary'
                                    onClick={() => modificarGasto(periodoD)}
                                >
                                    Modificar
                                </button>
                            }
                            <a
                                href = {`/#/produccion/${id_emp[5]}/gasto/${id_emp[7]}`}
                                className='btn btn-secondary mb-3'
                            >
                                Regresar
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

GastoForm.propTypes = {
    crear: PropTypes.bool,
    editar: PropTypes.bool,
    bloqueo: PropTypes.bool,
    modulo: PropTypes.object,
    periodoD: PropTypes.object,
    detalleInsumo: PropTypes.object,
    eliminarLineaProducto: PropTypes.func,
    periodoD: PropTypes.object,
    leerProductos: PropTypes.func,
    pro: PropTypes.object,
};

const Contenido = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

`;

export default reduxForm({
    form: 'FormGasto',
})(GastoForm);
